import $ from 'jquery'

export default {
    name: 'file-upload',
    components: {},
    props: {
        file_id: {
            type: String,
            default: ''
        },
        c_index: {
            type: Number,
            default: () => 0
        },
        is_required: {
            type: Boolean,
            default: false
        },
        file_ref: {
            type: String,
            default: ''
        },
        action_toggler: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            u_file: null,
        }
    },

    watch: {
        action_toggler() {
            this.u_file = null
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        handleFilesUpload(event) {
			$('.err-msg').fadeOut()
            const refName = this.file_ref;
			let uploaded_file = this.$refs[refName].files[0];

			console.log("ref name: ", refName);
            console.log(event);
			console.log("upf: ",uploaded_file);
			/*
			  Adds the uploaded file to the files array
			*/
            if (uploaded_file) {
                this.u_file = uploaded_file;
            } else {
                this.u_file = null
            }

            const response = {
                u_file: this.u_file,
                c_index: this.c_index,
            }
            this.$emit('emitFileUpload', response)
		},

        removeFile() {
            this.u_file = null;
            const response = {
                u_file: this.u_file,
                c_index: this.c_index,
            }
            this.$emit('emitFileUpload', response)
        }
    }
}